import "./Loader.css";

type LookstyLoaderVariant = "page" | "feed" | "details" | "master";

interface Props {
  variant?: LookstyLoaderVariant;
  title?: string;
  subtitle?: string;
}

export const LookstyLoader = ({ variant = "page", title = "Загружаем", subtitle = "Секунду, готовим красоту" }: Props) => {
  return (
    <div className={`looksty-loader looksty-loader-${variant}`}>
      <div className="looksty-loader-brand">
        <div className="looksty-loader-orbit">
          <i />
          <b />
          <span />
        </div>

        <div>
          <strong>{title}</strong>
          <p>{subtitle}</p>
        </div>
      </div>

      {variant === "feed" && (
        <div className="looksty-loader-feed-grid">
          {Array.from({ length: 8 }).map((_, index) => (
            <div className="looksty-loader-feed-card" key={index} />
          ))}
        </div>
      )}

      {variant === "details" && (
        <div className="looksty-loader-details">
          <div className="looksty-loader-details-image" />

          <div className="looksty-loader-details-content">
            <div className="looksty-loader-line wide" />
            <div className="looksty-loader-line price" />
            <div className="looksty-loader-pills">
              <span />
              <span />
            </div>
            <div className="looksty-loader-line text" />
            <div className="looksty-loader-master-row">
              <div />
              <section>
                <i />
                <b />
              </section>
            </div>
            <div className="looksty-loader-buttons">
              <span />
              <span />
            </div>
          </div>
        </div>
      )}
      {variant === "master" && (
        <div className="looksty-loader-master">
          <div className="looksty-loader-master-topbar">
            <span />
            <span />
          </div>

          <div className="looksty-loader-master-hero">
            <div className="looksty-loader-master-avatar" />

            <div className="looksty-loader-master-info">
              <div className="looksty-loader-line master-name" />
              <div className="looksty-loader-master-pills">
                <span />
                <span />
              </div>
              <div className="looksty-loader-line master-location" />
            </div>
          </div>

          <div className="looksty-loader-line master-description" />
          <div className="looksty-loader-line master-description short" />

          <div className="looksty-loader-master-button" />

          <div className="looksty-loader-master-tabs">
            <span />
            <span />
            <span />
          </div>

          <div className="looksty-loader-master-posts">
            {Array.from({ length: 6 }).map((_, index) => (
              <div className="looksty-loader-master-post" key={index} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
